import React, { useState } from "react";
import Swal from "sweetalert2";
import { useForm } from "../../hooks/useForm";
import { cargarPrequalificationsFilter } from "../../utils/Datos";
import { UrlWs } from "../../utils/Global";
import { Direcciones } from "../Otros/Direcciones";
import { Funcionarios } from "../Otros/Funcionarios";
import { PrecalificadoresPorDireccion } from "../Otros/PrecalificadoresPorDireccion";

const SelectDirecciones = ({ updateValue }) => {
  return <Direcciones updateValue={updateValue} />;
};

const SelectFuncionarios = ({ updateValue }) => {
  return <Funcionarios updateValue={updateValue} />;
};

const SelectPrecalificadores = ({ updateValue, direccion, idProcess }) => {
  return (
    <PrecalificadoresPorDireccion
      updateValue={updateValue}
      nuevoValue={null}
      direccion={direccion}
      idProcess={idProcess}
    ></PrecalificadoresPorDireccion>
  );
};

export const Filtrar = ({ setdatosFiltro, idProcess }) => {
  const [valoresForm, handleInputChange, reset, updateValue] = useForm({
    direccion: "",
    funcionarios: "",
    precalificadores: "",
  });
  const { direccion, funcionarios, precalificadores } = valoresForm;

  function cargar() {
    console.log(valoresForm);
    const url = UrlWs+"/prequalifications/filter";
    const respuesta = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id_municipalDirection: direccion,
        id_prequalifier: precalificadores,
        id_officer: funcionarios,
        id_process:idProcess
      }),
    })
      .then((response) => {
        if (response.status !== 200) {
          return null;
        } else {
          return response.json();
        }
      })
      .then((result) => {
        setdatosFiltro(result);
      });
  }

  const handleBuscar = () => {
    //cargar();
    cargarPrequalificationsFilter({
      id_municipalDirection: direccion,
      id_prequalifier: precalificadores,
      id_officer: funcionarios,
      id_process:idProcess
    }).then((dato) => {
      if (dato !== null) {
        setdatosFiltro(dato);
      } else {
        Swal.fire({
          icon: "Error",
          text: "No hay datos para mostrar",
          title: "Error",
        });
      }
    });
  };

  return (
    <div className="col-xl-12 ">
      <div className="card ">
        <div className="card-body ">
          <div className="row ">
            <div className="col-12 ">
              <div className="card-title flex-column ">
                <h3 className="mb-5 "> Filtrar</h3>
              </div>
            </div>
          </div>

          <div className="row ">
            <div className="col-lg-4 col-sm-12 ">
              <div className="mb-10 ">
                <label className="form-label ">Dirección municipal:</label>
                <SelectDirecciones updateValue={updateValue} />
              </div>
            </div>
            <div className="col-lg-4 col-sm-12 ">
              <div className="mb-10 ">
                <label className="form-label ">Precalificador:</label>
                <SelectPrecalificadores
                  updateValue={updateValue}
                  direccion={direccion}
                  idProcess={idProcess}
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-12 ">
              <div className="mb-10 ">
                <label className="form-label ">Funcionario:</label>
                <SelectFuncionarios updateValue={updateValue} />
              </div>
            </div>

            <div className="d-flex justify-content-end  px-9">
              <button onClick={handleBuscar} className="btn btn-sm btn-primary">
                 Buscar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
